export const ssiConfig = {
  "ssiBase": 160200,
  "ssiMaxBenefitAtFRA": 3627,
};

export const advisorConfigFields = [
  {
    valueFormat: "number",
    line: "Full Retirement Age (FRA) for Social Security <span>%</span>",
    label: "Full Retirement Age (FRA) for Social Security",
    altLine: "Full Retirement Age",
    fieldName: "fullRetirementAge",
    sliderParam: {
      min: 40,
      max: 90,
      step: 1,
      tickNumber: 6,
    },
  },
  {
    valueFormat: "number",
    line: "Age at Death <span>%</span>",
    label: "Age at Death",
    altLine: "Age at Death",
    fieldName: "ageOfDeath",
    sliderParam: {
      min: 70,
      max: 100,
      step: 1,
      tickNumber: 6,
    },
  },
  {
    valueFormat: "percentage",
    line: "Inflation Rate <span>%</span>",
    label: "Inflation Rate",
    altLine: "Inflation",
    fieldName: "inflationRate",
    sliderParam: {
      min: 0,
      max: 0.1,
      step: 0.001,
      tickNumber: 5,
    },
  },
  {
    valueFormat: "percentage",
    line: "Effective Tax Rate (Fed + State) before Retirement <span>%</span>",
    label: "Effective Tax Rate (Fed + State) before Retirement",
    altLine: "Before Retirement <span>%</span>",
    fieldName: "taxRateBR",
    sliderParam: {
      min: 0,
      max: 0.5,
      step: 0.001,
      tickNumber: 5,
    },
  },
  {
    valueFormat: "percentage",
    line: "Effective Tax Rate  (Fed + State) in Retirement <span>%</span>",
    label: "Effective Tax Rate  (Fed + State) in Retirement",
    altLine: "In Retirement <span>%</span>",
    fieldName: "taxRateIR",
    sliderParam: {
      min: 0,
      max: 0.5,
      step: 0.001,
      tickNumber: 5,
    },
  },
  {
    valueFormat: "percentage",
    line: "Effective Tax Rate (Fed + State) for Non-Qual Asset Gains <span>%</span>",
    label: "Effective Tax Rate (Fed + State) for Non-Qual Asset Gains",
    altLine: "For Non-Qual Asset Gains <span>%</span>",
    fieldName: "taxRateNonQualifiedAssetGains",
    sliderParam: {
      min: 0,
      max: 0.5,
      step: 0.001,
      tickNumber: 5,
    },
  },
];

export const defaultClientState = {
  firstName: "",
  lastName: "",
  phone: "",
  email: "",
  streetAddress: "",
  city: "",
  state: "",
  country: "United States",
  zipCode: "",
  dob: "",
  currentAge: 25,
  retirementAge: 45,
  currentIncome: 0,
  annualIncomeIncrease: 0,
  currentQualifiedPlans: 0,
  currentNonQualifiedSavings: 0,
  annualQualifiedPlans: 0,
  annualNonQualifiedSavings: 0,
  monthlySSI: 0,
  monthlyPension: 0,
  otherAnnualIncome: 0,
  otherAnnualIncomeYears: 0,
  combinedAnnualExpenseBR: 0,
  monthlyExpensesBR: 0,
  expensesPercentageToIncomeBR: 0,
  combinedAnnualExpenseIR: 0,
  monthlyExpensesIR: 0,
  expensesPercentageToIncomeIR: 0,
  valid: false,
};

export const clientFields = [
  {
    slider: 0,
    valueFormat: "number",
    line: "Retirement Age <span>%</span>",
    label: "Retirement Age",
    fieldName: "retirementAge",
    householdCommon: false,
    sliderParam: {
      min: 45,
      max: 95,
      step: 1,
      tickNumber: 6,
    },
  },
  {
    slider: 0,
    valueFormat: "dollar",
    line: "Annual Income <span>%</span>",
    label: "Annual Income",
    fieldName: "currentIncome",
    householdCommon: false,
    sliderParam: {
      min: 0,
      max: 1000000,
      step: 5000,
      tickNumber: 5,
    },
  },
  {
    slider: 0,
    valueFormat: "percentage",
    line: "Annual Income Increase <span>%</span>",
    label: "Annual Income Increase",
    fieldName: "annualIncomeIncrease",
    householdCommon: false,
    sliderParam: {
      min: 0,
      max: 0.1,
      step: 0.005,
      tickNumber: 5,
    },
  },
  {
    slider: 1,
    valueFormat: "dollar",
    line: "Qualified Plans (IRA, 401k, etc.) <span>%</span>",
    label: "Qualified Plans (IRA, 401k, etc.)",
    fieldName: "currentQualifiedPlans",
    householdCommon: false,
    sliderParam: {
      min: 0,
      max: 3000000,
      step: 5000,
      tickNumber: 4,
    },
  },
  {
    slider: 1,
    valueFormat: "dollar",
    line: "Annual Qualified Plan Contributions (Employee + Employer) <span>%</span>",
    label: "Annual Qualified Plan Contributions (Employee + Employer)",
    fieldName: "annualQualifiedPlans",
    householdCommon: false,
    sliderParam: {
      min: 0,
      max: 50000,
      step: 1000,
      tickNumber: 5,
    },
  },
  {
    slider: 1,
    valueFormat: "dollar",
    line: "Other Household Investments/Savings <span>%</span>",
    label: "Other Household Investments/Savings",
    fieldName: "currentNonQualifiedSavings",
    householdCommon: true,
    sliderParam: {
      min: 0,
      max: 3000000,
      step: 5000,
      tickNumber: 4,
    },
  },
  {
    slider: 1,
    valueFormat: "dollar",
    line: "Annual Household Investments/Savings <span>%</span>",
    label: "Annual Household Investments/Savings",
    fieldName: "annualNonQualifiedSavings",
    householdCommon: true,
    sliderParam: {
      min: 0,
      max: 500000,
      step: 1000,
      tickNumber: 5,
    },
  },
  {
    slider: 2,
    valueFormat: "dollar",
    line: "Monthly Social Security Income (Leave 0 to Use Calculation Estimate) <span>%</span>",
    label:
      "Monthly Social Security Income (Leave 0 to Use Calculation Estimate)",
    fieldName: "monthlySSI",
    householdCommon: false,
    sliderParam: {
      min: 0,
      max: 3000,
      step: 100,
      tickNumber: 5,
    },
  },
  {
    slider: 2,
    valueFormat: "dollar",
    line: "Monthly Pension <span>%</span>",
    label: "Monthly Pension",
    fieldName: "monthlyPension",
    householdCommon: false,
    sliderParam: {
      min: 0,
      max: 20000,
      step: 1000,
      tickNumber: 5,
    },
  },
  {
    slider: 2,
    valueFormat: "dollar",
    line: "Other Annual Income (Part Time, etc.) <span>%</span>",
    label: "Other Annual Income (Part Time, etc.)",
    fieldName: "otherAnnualIncome",
    householdCommon: false,
    sliderParam: {
      min: 0,
      max: 1000000,
      step: 1000,
      tickNumber: 5,
    },
  },
  {
    slider: 2,
    valueFormat: "number",
    line: "For how many years? <span>%</span>",
    label: "For how many years?",
    fieldName: "otherAnnualIncomeYears",
    householdCommon: false,
    sliderParam: {
      min: 0,
      max: 20,
      step: 1,
      tickNumber: 5,
    },
  },
  // {
  //   slider: 3,
  //   valueFormat: 'dollar',
  //   line: 'Annual Expenses Pre-Retirement <span>%</span>',
  //   label: 'Annual Expenses Pre-Retirement',
  //   fieldName: 'combinedAnnualExpenseBR',
  //   householdCommon: true,
  //   sliderParam: {
  //     min: 0,
  //     max: 1000000,
  //     step: 10000,
  //     tickNumber: 5
  //   }
  // },
  {
    slider: 3,
    valueFormat: "dollar",
    line: "Monthly Expenses <b>Pre-Retirement</b> <span>%</span>",
    label: "Monthly Expenses Pre-Retirement",
    fieldName: "monthlyExpensesBR",
    householdCommon: true,
    sliderParam: {
      min: 0,
      max: 50000,
      step: 1000,
      tickNumber: 5,
    },
  },
  {
    slider: 3,
    valueFormat: "percentage",
    line: "(or) &#37; of Current Income <span>%</span>",
    label: "(or) &#37; of Current Income",
    fieldName: "expensesPercentageToIncomeBR",
    householdCommon: true,
    addSpace: true,
    sliderParam: {
      min: 0,
      max: 1,
      step: 0.01,
      tickNumber: 5,
    },
  },
  // {
  //   slider: 4,
  //   valueFormat: 'dollar',
  //   line: 'Annual Expenses In Retirement <span>%</span>',
  //   label: 'Annual Expenses In Retirement',
  //   fieldName: 'combinedAnnualExpenseIR',
  //   householdCommon: true,
  //   sliderParam: {
  //     min: 10000,
  //     max: 1000000,
  //     step: 10000,
  //     tickNumber: 5
  //   }
  // },
  {
    slider: 3,
    valueFormat: "dollar",
    line: "Monthly Expenses <b>in Retirement</b> <span>%</span>",
    label: "Monthly Expenses in Retirement",
    fieldName: "monthlyExpensesIR",
    householdCommon: true,
    sliderParam: {
      min: 0,
      max: 50000,
      step: 1000,
      tickNumber: 5,
    },
  },
  {
    slider: 3,
    valueFormat: "percentage",
    line: "(or) &#37; of Current Income <span>%</span>",
    label: "(or) &#37; of Current Income",
    fieldName: "expensesPercentageToIncomeIR",
    householdCommon: true,
    sliderParam: {
      min: 0,
      max: 1,
      step: 0.01,
      tickNumber: 5,
    },
  },
];

export const paperworkConst = {
  title: "Paperwork",
  contents: [
    "Are you looking for additional paperwork to open your Cy accounts?",
    "You’ve come to the right place. Please see below for our library of available documents.",
    "Your printed proposal serves as your Cy Account opening paperwork. The links below are to custodial documents with Pershing Advisor Solutions.",
    "A document packet below should accompany your Cy Account opening paperwork. Should you use a different custodian, please contact your wholesaler.",
    "If you don’t see the account type you’re looking for below, please contact your wholesaler. ",
  ],
  links: [
    {
      id: 0,
      label: "Individual Account Packet",
      url: "https://quikforms.com/viewform/zq5n-ltykf4sO",
    },
    {
      id: 1,
      label: "Joint Account",
      url: "https://quikforms.com/viewform/zq5n-ltykf4sO",
    },
    {
      id: 4,
      label: "Traditional IRA Account",
      url: "https://quikforms.com/viewform/zq5n-zANoDI81",
    },
    {
      id: 5,
      label: "Roth IRA Account",
      url: "https://quikforms.com/viewform/zq5n-3T7FVdzI",
    },
    {
      id: 6,
      label: "Inherited IRA Account",
      url: "https://quikforms.com/viewform/zq5n-0PloccrR",
    },
    {
      id: 7,
      label: "Trust Account",
      url: "https://quikforms.com/viewform/zq5n-GHjge4VO",
    },
    {
      id: 8,
      label: "Account Replicate Form",
      url: "https://quikforms.com/viewform/zq5n-A0XYUTUd",
    },
  ],
};

export const RESTRICTED_BROKERS = [
  // 'Cambridge Investment Research, Inc.'
]


// WEBPACK FOOTER //
// ./src/utilities/constant.js